import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// tremor
import { Callout as TremorCallout } from "@tremor/react";

const Callout = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <Row style={{marginBottom:22}}>
            <Container>
                <TremorCallout
                    title={props.title}
                    text={props.subtitle}
                    height="h-12"
                    color={props.color}
                    marginTop="mt-2"
                />
        </Container>
      </Row>
    );
};

export default Callout;